const es = {
  tools_actions: {
    hotel_info: "Consulto la información del hotel...",
    accommodation_info: "Consulto la información del hotel...",
    accomodation_info: "Consulto la información del hotel...",
    get_destination_info: "Busco qué hacer en los alrededores...",
    get_guest_information: "Compruebo su reserva...",
    book_hotel_service_or_get_availability: "Compruebo la disponibilidad del servicio...",
    list_accomodations: "Cargo los alojamientos...",
    set_accomodation: "Cargo el alojamiento...",
    list_accommodations: "Cargo los alojamientos...",
    set_accommodation: "Cargo el alojamiento...",
    destination_info: "Busco qué hacer en los alrededores...",
    show_map: "Preparo el mapa...",
    consult_rules: "Consulto las normas del alojamiento...",
    notify_reception: "Aviso a recepción...",
    save_self_declared_stay: "Registro tu estancia...",
    generate_quote_for_single_room_longstay_rooms: "Preparo un presupuesto...",
    generate_quote_for_multiple_rooms_longstay: "Preparo un presupuesto...",
    hotel_info_iodah:
      "Perfecto, recopilo la información y estoy con usted en un momento...",
    generate_quote_for_rooms: "Preparo un presupuesto...",
    check_availability: "Compruebo la disponibilidad...",
    print_calendar: "Consulto el calendario...",
    nearby_restaurants: "Busco restaurantes cercanos...",
    nearby_attractions: "Busco atracciones cercanas...",
    human_handoff: "Le paso con un operador...",
    tool_search_offers_by_request: "Busco las mejores ofertas para usted...",
    tool_search_hotels_by_request: "Busco los mejores hoteles para usted...",
  },
  tool_status_sequences: {
    generate_quote_for_rooms: [
      "Compruebo la disponibilidad para sus fechas…",
      "Comparo habitaciones y tarifas…",
      "Preparo su presupuesto…",
    ],
    generate_quote_for_single_room_longstay_rooms: [
      "Compruebo la disponibilidad para sus fechas…",
      "Comparo habitaciones y tarifas…",
      "Preparo su presupuesto…",
    ],
    generate_quote_for_multiple_rooms_longstay: [
      "Compruebo la disponibilidad para sus fechas…",
      "Comparo habitaciones y tarifas…",
      "Preparo su presupuesto…",
    ],
    check_availability: [
      "Consulto el calendario…",
      "Verifico la disponibilidad…",
      "Un momento más…",
    ],
    hotel_info: [
      "Consulto la información del hotel…",
      "Recopilo los detalles…",
      "Preparo la respuesta…",
    ],
    accommodation_info: [
      "Consulto la información del hotel…",
      "Recopilo los detalles…",
      "Preparo la respuesta…",
    ],
    accomodation_info: [
      "Consulto la información del hotel…",
      "Recopilo los detalles…",
      "Preparo la respuesta…",
    ],
    get_destination_info: [
      "Exploro los alrededores…",
      "Selecciono las mejores sugerencias…",
      "Casi listo…",
    ],
    nearby_restaurants: [
      "Busco restaurantes en la zona…",
      "Selecciono los más adecuados…",
      "Casi listo…",
    ],
    nearby_attractions: [
      "Busco qué hacer en los alrededores…",
      "Selecciono lo mejor…",
      "Casi listo…",
    ],
    get_guest_information: [
      "Recupero su reserva…",
      "Compruebo los detalles de su estancia…",
      "Un momento más…",
    ],
    book_hotel_service_or_get_availability: [
      "Compruebo la disponibilidad del servicio…",
      "Verifico los horarios…",
      "Un momento más…",
    ],
    print_calendar: ["Abro el calendario…", "Consulto las fechas…"],
    list_accomodations: ["Cargo los alojamientos…", "Preparo la lista…"],
    set_accomodation: ["Abro el alojamiento…", "Recupero la información…"],
    list_accommodations: ["Cargo los alojamientos…", "Preparo la lista…"],
    set_accommodation: ["Abro el alojamiento…", "Recupero la información…"],
    destination_info: [
      "Exploro los alrededores…",
      "Selecciono las mejores sugerencias…",
      "Casi listo…",
    ],
    show_map: ["Localizo los lugares en el mapa…", "Preparo el itinerario…"],
    consult_rules: ["Consulto las normas del alojamiento…", "Verifico las condiciones…"],
    notify_reception: ["Aviso a recepción…", "Envío la solicitud…"],
    save_self_declared_stay: ["Registro tu estancia…", "Vinculo la reserva…"],
    human_handoff: ["Aviso a recepción…", "Paso la conversación…"],
    tool_search_offers_by_request: [
      "Busco las mejores ofertas para usted…",
      "Comparo las opciones…",
      "Casi listo…",
    ],
    tool_search_hotels_by_request: [
      "Busco los hoteles más adecuados…",
      "Comparo las opciones…",
      "Casi listo…",
    ],
  },
  status_thinking: ["Un momento…", "Lo estoy pensando…", "Un instante más…"],
  status_generic: ["Ya casi está…", "Un instante más…"],
  tooltip_sentences: [
    "¿Quiere un presupuesto rápido? 😊",
    "¿Necesita información sobre el hotel? 😊",
  ],
  tooltip_sentences_iodah: [
    "Bienvenido a The First Hotels.",
    "¿Cómo puedo ayudarte hoy?",
  ],
  // Variant B of the open-rate experiment: two clickable teaser pills ·
  // a fixed high-intent hook on top, a rotating multi-intent pill below.
  // A click opens the chat and sends the pill as the guest message.
  // Hotels can override these from the backoffice (per locale); these are
  // the defaults when no configuration is present.
  welcome_message_default:
    "¡Hola! 👋 Soy el asistente virtual del hotel. Puedo consultar disponibilidad y precios y responder a cualquier pregunta sobre su estancia. ¿En qué puedo ayudarle?",
  teaser_pill_fixed: "Presupuesto en 30 segundos ⚡",
  teaser_pills_rotating: [
    "¿Hay disponibilidad para mis fechas? 📅",
    "¿Qué habitaciones tienen? 🛏️",
    "¿Cómo es el desayuno? 🥐",
  ],
  quote_pills: {
    alone: "Solo yo",
    alone_message: "Solo yo, una persona",
    party: "Somos {n}",
    party_message: "Somos {n} personas",
  },
  replies_in_realtime: "Respuestas en tiempo real",
  ai_disclosure: "Soy el asistente de IA del alojamiento. Puede pedir hablar con el personal cuando prefiera.",
  assistant_default_name: "Nombre del asistente",
  powered_by: "Desarrollado por",
  type_a_message: "Escriba un mensaje...",
  speak_with_operator: "Hablar con un operador",
  // "Call us" card in the welcome message (VoiceCallCard).
  voice_call: {
    title: "Llámanos",
    subtitle: "Nuestro asistente de voz responde al instante",
    badge: "Nuevo",
    call: "Llamar",
    copy: "Copiar el número",
    copied: "Número copiado",
  },
  voice_panel: {
    status_idle: "Lista",
    status_connecting: "Preparando la voz...",
    status_listening: "Escuchando",
    status_error: "Error de conexión",
    status_warming: "Calentando la voz...",
    transcript_empty: "Di algo…",
    end_call: "Finalizar llamada",
    start_call: "Iniciar llamada de voz",
    start_mode: "Activar el modo de voz",
    stop_mode: "Detener el modo de voz",
  },
  continue_on_whatsapp: "Continuar en WhatsApp",
  whatsapp_handoff_prefill:
    "¡Hola! Estaba escribiendo con el asistente en la web y me gustaría continuar aquí.",
  request_quote: "Solicitar un presupuesto",
  map_directions: "Abrir en Maps",
  handoff_form: {
    title: "Contáctenos",
    desc: "Déjenos sus datos y nuestro equipo se pondrá en contacto con usted lo antes posible.",
    firstname: "Nombre",
    lastname: "Apellidos",
    email: "Email",
    phone: "Teléfono",
    phone_hint: "Lo usaremos para contactarle, también por WhatsApp.",
    phone_search: "Buscar país",
    submit: "Enviar Solicitud",
    success:
      "¡Gracias! Hemos recibido sus datos y nos pondremos en contacto con usted lo antes posible. 😊",
    handoff_email_success:
      "Te responderemos por correo a {email}. Puedes cerrar esta página.",
    submit_error: "Algo ha ido mal. Inténtalo de nuevo en breve.",
    firstname_error: "Introduzca su nombre.",
    lastname_error: "Introduzca sus apellidos.",
    email_error: "Introduzca una dirección de email válida.",
    phone_error: "Introduzca un número de teléfono válido.",
    close_aria_label: "Cerrar",
  },
  error_generic: "Algo salió mal. Inténtalo de nuevo más tarde.",
  delete_chat_aria_label: "Eliminar Conversación",
  close_aria_label: "Cerrar Conversación",
  send_aria_label: "Enviar Mensaje",
  chat_widget_aria_label: "Widget de chat",
  previous_aria_label: "Anterior",
  next_aria_label: "Siguiente",
  attachment_alt: "Adjunto",
  assistant_icon_alt: "Icono del asistente",
  bot_avatar_alt: "Avatar del asistente",
  video_label: "Vídeo {n}",
  open_content: "Abrir Contenidos",
  book_now: "Reservar Ahora",
  // Inline link chips in a message (CustomLinkRenderer): shown next to the
  // address/number the assistant wrote, and used as the accessible label.
  send_email: "Enviar un correo",
  call_now: "Llamar",
  whatsapp_chat: "Escríbenos por WhatsApp",
  open_link: "Abrir el enlace",
  discover_hotel: "Descubra el hotel",
  discover_offer: "Descubra la oferta",
  quick_quote: "Pida un presupuesto",
  view_hotel_photos: "Ver las fotos del hotel",
  view_photos: "Ver las fotos",
  hotel_gallery: "Hotel",
  restaurant_gallery: "Restaurante",
  animation_gallery: "Animación",
  rooms_gallery: "Habitaciones",
  look_hotel_galleries: "Vea las demás galerías del hotel:",
  back_to_chat: "Volver al chat",
  carousel_open: "Abrir",
  carousel_close: "Cerrar",
  available: "Disponible",
  expand_view: "Vista inmersiva",
  read_more: "Leer más",
  explore: "Explorar",
  photo: "Foto",
  from_price: "desde",
  rates: "Tarifas",
  quote_group: {
    title: "Su presupuesto",
    total: "Total",
    room: "Habitación {n}",
    other_options: "Otras opciones",
    rooms: "{n} habitaciones",
    adult: "adulto",
    adults: "adultos",
    child: "niño",
    children: "niños",
  },
  anchor_rooms: "Nuestras propuestas",
  anchor_discover: "Para descubrir",
  anchor_places: "Ubicación y alrededores",
  anchor_videos: "Vídeos",
  videos: "vídeos",
  watch_video: "Ver el vídeo",
  feedback_useful: "Respuesta útil",
  feedback_not_useful: "Poco útil",
  proposal: "propuesta",
  proposals: "propuestas",
  contents: "contenidos",
  places: "lugares",
  explore_title: "Su estancia",
  explore_rooms: "Habitaciones y tarifas",
  explore_discover: "Para descubrir",
  explore_videos: "Vídeos",
  explore_places: "Lugares",
  directions: "Cómo llegar",
  minimize_view: "Reducir",

  // 1x6 P2-d-M · interactive concierge map (poi_map / itinerary templates).
  anchor_itinerary: "Tu itinerario",
  itinerary: "Itinerario",
  stops: "paradas",
  stop: "parada",
  walk_min: "min a pie",
  itinerary_start: "Punto de partida",
  your_hotel: "Tu hotel",
  explore_itineraries: "Itinerarios",
  map_loading: "Cargando el mapa…",
  cat_restaurant: "Comer y beber",
  cat_attraction: "Atracciones",
  cat_beach: "Playas",
  cat_essential: "Servicios útiles",
  cat_event: "Eventos",
  cat_place: "Lugar",
  reviews: "opiniones",

  booking: {
    choose_rate: "Elige la tarifa",
    your_details: "Tus datos",
    review: "Resumen",
    notes: "Notas o peticiones",
    notes_placeholder: "Alergias, hora de llegada, cuna…",
    privacy: "He leído y acepto la política de privacidad.",
    marketing: "Quiero recibir ofertas y novedades del hotel.",
    privacy_required:
      "Se necesita el consentimiento de privacidad para continuar.",
    continue: "Continuar",
    back: "Atrás",
    confirm: "Confirmar reserva",
    submitting: "Un momento…",
    cancel: "Cancelar",
    close: "Cerrar",
    retry: "Reintentar",
    total: "Total",
    cheapest: "Más económica",
    per_night: "por noche",
    no_payment_now: "Sin pago ahora",
    nights: "noches",
    guests: "huéspedes",
    reference: "Referencia",
    success_title: "Reserva confirmada",
    success_body: "Recibirás la confirmación por email en breve.",
    error_title: "No se ha completado",
    error_body:
      "No hemos podido completar la reserva. Inténtalo de nuevo en unos minutos.",
    mock_notice: "Modo de prueba: no se ha creado ninguna reserva real.",
  },
};

export default es;
